/** Bloque de dirección de entrega para cards/review de bodega. */
export function entregaParts(pedido) {
  if (!pedido) return { line: '', ciudadZona: '', esSede: false };
  const direccion = String(
    pedido.sucursal_direccion || pedido.entrega_direccion || pedido.direccion || ''
  ).trim();
  const ciudad = String(pedido.ciudad || pedido.sucursal_ciudad || '').trim();
  const zona = String(pedido.zona || pedido.sucursal_zona || '').trim();
  const ciudadZona = [ciudad, zona].filter(Boolean).join(' · ');
  const esSede = Boolean(pedido.es_sede || pedido.padre_codigo);
  const line = direccion || ciudadZona || '';
  return { line, direccion, ciudad, zona, ciudadZona, esSede };
}

export function pedidoClienteDisplay(pedido) {
  if (!pedido) return '—';
  const nombre = String(pedido.cliente_nombre || '').trim() || '—';
  if (pedido.es_sede || pedido.padre_codigo) {
    const padre = pedido.padre_codigo || '';
    const sede = String(pedido.sede_etiqueta || '').trim() || 'Sede';
    return padre ? `${padre} · ${sede}` : `Sucursal: ${sede}`;
  }
  return nombre;
}

const PAGO_LABEL = {
  contado: 'Contado',
  credito_15: 'Crédito 15 días',
  credito_20: 'Crédito 20 días',
  credito_30: 'Facturación a 30 días',
};

export function labelFormaPago(v) {
  if (!v) return '';
  return PAGO_LABEL[v] || String(v).replace(/_/g, ' ');
}

/** Datos que deben verse siempre al separar (igual que la remisión). */
export function pedidoDatosFicha(pedido) {
  const e = entregaParts(pedido);
  const codigo = String(pedido?.sucursal_codigo || pedido?.padre_codigo || '').trim();
  return {
    nombre: String(pedido?.cliente_nombre || '').trim() || '—',
    codigo: codigo || '—',
    telefono: String(pedido?.cliente_telefono || '').trim() || '—',
    direccion: e.direccion || '—',
    ciudadZona: e.ciudadZona || '',
    esSede: e.esSede,
    sedeEtiqueta: String(pedido?.sede_etiqueta || '').trim(),
    vendedor: String(pedido?.vendedor || '').trim() || '—',
    pago: labelFormaPago(pedido?.forma_pago) || '—',
    horario: String(pedido?.horario_recibo || '').trim() || '—',
    transportadora: String(pedido?.transportadora || '').trim(),
    observaciones: String(pedido?.notas || '').trim(),
  };
}
